// Module
var code = "<li class=\"city\" rv-class-city--top=\"isTopCity\">\n\t<button class=\"city__button\" rv-on-click=\"view.select\">\n\t\t<span class=\"city__name\">{ city.name }</span>\n\t\t<span class=\"city__placecount\">{ label }</span>\n\t</button>\n</li>\n";
// Exports
module.exports = code;